import { storyblokEditable } from '@storyblok/react';
import { Button, Container, Typography } from '@krakentech/coral';
import Image from 'next/image';
import {
    StyledHero,
    StyledFullHeightContainer,
    StyledGrid,
    StyledH1,
    StyledCenterAlign,
} from './index.styled';
import { HeroStoryblok } from '@/types/generated/storyblok/schema';

type DynamicHeroProps = {
    blok: HeroStoryblok;
};

const DynamicHero = ({ blok }: DynamicHeroProps) => (
    <StyledHero
        {...storyblokEditable(blok)}
        large={blok.large}
        imageUrl={blok.hero_image?.filename}
    >
        <StyledFullHeightContainer theme="none">
            <Container theme="none">
                {blok.large ? (
                    <StyledGrid>
                        <div>
                            <StyledCenterAlign>
                                <Typography variant="h1">
                                    <StyledH1>{blok.hero_title}</StyledH1>
                                </Typography>
                                <Typography variant="body1">
                                    <strong>
                                        We&apos;re the climate action group for
                                        tech companies of all sizes committed to
                                        fighting the climate crisis. We believe
                                        that by joining forces, we can make
                                        faster progress to net zero.
                                    </strong>
                                </Typography>
                                <Button href="/join">Join Tech Zero</Button>
                            </StyledCenterAlign>
                        </div>
                        <div>
                            <StyledCenterAlign>
                                <Image
                                    src="/images/tz-powered-by-octopus-tn.png"
                                    alt="Tech Zero powered by Octopus Energy and Tech Nation"
                                    layout="responsive"
                                    width={1000}
                                    height={1000}
                                    priority
                                />
                            </StyledCenterAlign>
                        </div>
                    </StyledGrid>
                ) : (
                    <Typography variant="h1">
                        <StyledH1>{blok.hero_title}</StyledH1>
                    </Typography>
                )}
            </Container>
        </StyledFullHeightContainer>
    </StyledHero>
);

export default DynamicHero;
